<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    :class="`relative z-40 text-pretty text-base/[22px] [&_a]:underline [&_a]:decoration-1 [&_a]:underline-offset-[5px] [&_blockquote]:text-xs/[16px] [&_figcaption]:hidden [&_figure:first-of-type_img]:lg:my-20 [&_figure:first-of-type_img]:lg:py-0 [&_h1]:text-[30px]/[34px] [&_img]:my-10 [&_img]:w-full [&_img]:max-w-none [&_img]:bg-avu-gray [&_img]:lg:my-20 lg:[&_img]:[width:calc(60vw-66px-var(--scrollbar-width))] [&_img]:2xl:mr-[20vw] [&_ol]:list-decimal [&_ol]:space-y-2 [&_ul]:list-inside [&_ul]:list-disc [&_ul]:space-y-1`"
    :style="{
      '--scrollbar-width': computedScrollbarWidth,
    }"
    v-html="parsedContent"
  />
</template>

<script setup>
  import { ref, watchEffect, onMounted } from "vue";

  const props = defineProps({
    content: {
      type: String,
      default: "",
    },
  });
  const scrollbarWidth = ref(null);
  const parsedContent = ref(props.content);
  const computedScrollbarWidth = computed(() => {
    return scrollbarWidth.value ? `${scrollbarWidth.value - 2}px` : "0px";
  });

  const isScrollbarVisible = () => {
    if (typeof window === "undefined" || typeof document === "undefined")
      return false;

    const scrollDiv = document.createElement("div");
    scrollDiv.style.visibility = "hidden";
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "100px";
    scrollDiv.style.height = "100px";

    document.body.appendChild(scrollDiv);

    const scrollbarVisible = scrollDiv.offsetWidth > scrollDiv.clientWidth;
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    document.body.removeChild(scrollDiv);

    return {
      scrollbarVisible,
      scrollbarWidth,
    };
  };

  onMounted(() => {
    const { scrollbarWidth: resultScrollbarWidth } = isScrollbarVisible();
    scrollbarWidth.value = resultScrollbarWidth;
  });

  const parseContent = (html) => {
    if (typeof window === "undefined") {
      return html;
    }

    const div = document.createElement("div");
    div.innerHTML = html;

    const links = div.querySelectorAll("a");
    links.forEach((link) => {
      if (link.querySelector("img")) {
        while (link.firstChild) {
          link.parentNode.insertBefore(link.firstChild, link);
        }
        link.remove();
      }
    });

    return div.innerHTML;
  };

  watchEffect(() => {
    parsedContent.value = parseContent(props.content || "");
  });
</script>
